import React, { useState } from 'react';
import axios from 'axios';
import '../styles/Register.css';

function Registration() {
  const [formData, setFormData] = useState({
    email: '',
    organization: '',
    fullName: '',
    password: '',
    termsAccepted: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post('http://app.sam-uday.in:5000/register', formData);
      alert('Registration successful!');
      console.log(response.data);
    } catch (error) {
      alert('Registration failed. Please try again.');
      console.error(error.response?.data || error.message);
    }
  };

  return (
    <div className="registration-container">
      <h2>Register</h2>
      <form onSubmit={handleSubmit}>
        <input type="email" name="email" placeholder="Email Address" value={formData.email} onChange={handleChange} required />
        <input type="text" name="organization" placeholder="Organization Name" value={formData.organization} onChange={handleChange} required />
        <input type="text" name="fullName" placeholder="Full Name" value={formData.fullName} onChange={handleChange} required />
        <input type="password" name="password" placeholder="Password" value={formData.password} onChange={handleChange} required />
        <div>
          <input type="checkbox" name="termsAccepted" checked={formData.termsAccepted} onChange={handleChange} required />
          <label>I accept the Terms and Conditions</label>
        </div>
        <button type="submit">Register</button>
      </form>
    </div>
  );
}

export default Registration;
